import { render, staticRenderFns } from "./ComparadorFolios.vue?vue&type=template&id=8d24278a&scoped=true"
import script from "./ComparadorFolios.vue?vue&type=script&lang=js"
export * from "./ComparadorFolios.vue?vue&type=script&lang=js"
import style0 from "./ComparadorFolios.vue?vue&type=style&index=0&id=8d24278a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d24278a",
  null
  
)

export default component.exports